import React from "react";
import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/walkthrough", label: "Design walkthrough", testId: "nav-walkthrough" },
  { to: "/sponsor", label: "Sponsor view", testId: "nav-sponsor" },
  { to: "/requests", label: "Requests", testId: "nav-requests" },
  { to: "/portfolio", label: "Portfolio", testId: "nav-portfolio" },
];

export default function Header() {
  return (
    <header className="border-b border-slate-200 bg-[var(--bg-primary)]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex items-center justify-between gap-8">
        <Link to="/" className="flex flex-col" data-testid="brand-link">
          <span className="font-display text-2xl tracking-tight text-[var(--ink-heading)]">
            GovDataCierge
          </span>
          <span className="text-xs text-[var(--ink-muted)] mt-0.5">
            Federated governance for AI-ready data reuse
          </span>
        </Link>
        <nav className="flex items-center gap-6 text-sm" data-testid="primary-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `transition-colors ${
                  isActive
                    ? "text-[var(--ink-heading)] font-medium"
                    : "text-[var(--ink-secondary)] hover:text-[var(--ink-heading)]"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
